import {Injectable} from "@angular/core";
import {ClientVolumesService} from "../../models/client-volumes/client-volumes.service";
import {PermissionsService} from "../../services/permissions/permissions.service";
import {PricingsService} from '../../models/pricings/pricings.service';
import {ClientsService} from "../../models/clients/clients.service";


let globalInfo: any = null;


@Injectable()
export class FloatingButtonGlobalInfo_hidden
{
    constructor(
        public permission: PermissionsService,
        public clientVolumesService: ClientVolumesService,
        public clientsService: ClientsService,
        public pricingsService: PricingsService,
    ) {
        if (globalInfo) throw 'ERROR!!! Global Info Already Activated!!!';
        globalInfo = this;
    }
    /*
    private clientStack: any = [];

    get clientId(): any {
        if (this.clientStack.length > 0.5) {
            let result: any = this.clientStack[this.clientStack.length - 1];
            if (isFinite(result)) return result;
            return null;
        }
        return null;
    }
    
    pushClientId(id: any) {
        let _empty_res: any = {};
        let i: any = this.clientStack.push(_empty_res) - 1;
        this.clientVolumesService.getListByClient(id)
            .subscribe((res) => {
                if (this.clientStack[i] !== _empty_res) return;
                try {
                    if (! res.data.length) {
                        this.clientStack[i] = null;
                        return;
                    }
                    let _id: any = id * 1;
                    if (! isFinite(_id) || _id < 0.5 || _id != Math.round(_id))
                        _id = null;
                    this.clientStack[i] = _id;
                } catch (_e) {
                    if (this.clientStack[i] !== _empty_res) return;
                    this.clientStack[i] = null;
                }
            });
    }

    pushPricingId(pricing_id: any) {
        let _empty_res: any = {};
        let i: any = this.clientStack.push(_empty_res) - 1;

        this.pricingsService.getOne(pricing_id)
            .subscribe((res) => {
                if (this.clientStack[i] !== _empty_res) return;
                try {
                    let _id: any = res.data.client_id * 1;
                    if (! isFinite(_id) || _id < 0.5 || _id != Math.round(_id)) {
                        this.clientStack[i] = null;
                        return;
                    }
                    this.clientVolumesService.getListByClient(_id)
                        .subscribe((res) => {
                            if (this.clientStack[i] !== _empty_res) return;
                            if (! res.data.length) {
                                this.clientStack[i] = null;
                                return;
                            }
                            this.clientStack[i] = _id;
                        });
                } catch (_e) {
                    if (this.clientStack[i] !== _empty_res) return;
                    this.clientStack[i] = null;
                }
            })
        
    }
    
    popOne() {
        if (this.clientStack.length > 0.5) {
            this.clientStack.pop();
        }
    }
    */
    private _clientId: any = null;
    private _stackCount: any = 0;
    private _disabled_value: any = false;

    private _has_debt = null;

    get clientId(): any {
        if (! this._disabled_value && this._stackCount > 0.5) {
            return this._clientId;
        }
        return null;
    }

    get hasDebt(): any {
        if (! this.clientId) return null;
        return this._has_debt;
    }
    
    pushClientId(id: any) {
        this._stackCount++;
        if (this._clientId) return;

        this.clientVolumesService.getListByClient(id)
            .subscribe((res) => {
                if (this._clientId) return;
                try {
                    if (! res.data.length)
                        return;
                    let _id: any = id * 1;
                    if (! isFinite(_id) || _id < 0.5 || _id != Math.round(_id))
                        _id = null;
                    
                    this.clientsService.hasDebt(_id)
                        .subscribe((res) => {
                            if (this._clientId) return;

                            this._clientId = _id;
                            this._has_debt = res.data;
                        });
                } catch (_e) {
                    if (this._clientId) return;
                    this._clientId = null;
                }
            });
    }

    pushPricingId(pricing_id: any) {
        this._stackCount++;
        if (this._clientId) return;

        this.pricingsService.getOne(pricing_id)
            .subscribe((res) => {
                if (this._clientId) return;
                try {
                    let _id: any = res.data.client_id * 1;
                    if (! isFinite(_id) || _id < 0.5 || _id != Math.round(_id))
                        return;

                    this.clientVolumesService.getListByClient(_id)
                        .subscribe((res) => {
                            if (this._clientId) return;
                            if (! res.data.length) return;

                            this.clientsService.hasDebt(_id)
                                .subscribe((res) => {
                                    if (this._clientId) return;

                                    this._clientId = _id;
                                    this._has_debt = res.data;
                                });
                        });
                } catch (_e) {
                    if (this._clientId) return;
                    this._clientId = null;
                }
            })
        
    }
    
    popOne() {
        if (this._stackCount > 0.5) {
            this._stackCount--;
        }
        if (this._stackCount < 0.5) {
            this._clientId = null;
        }
    }

    disableValue() {
        this._disabled_value = true;
    }

    enableValue() {
        this._disabled_value = false;
    }
}


export const floatingButtonX: any = () => {
    if (! globalInfo) {
        throw 'ERROR!!! Global Info NOT Activated!!!';
    }
    return globalInfo;
};


// WEBPACK FOOTER //
// ./src/app/modules/floating-button/xservice.ts